import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { PageSlice } from '@contracts';

interface Props {
  slice: PageSlice;
}

const ImageSlice: React.FC<Props> = ({ slice }) => {
  const image = getImage(slice.primary?.image);

  return (
    <ImageWrap $width={slice.primary?.width.text} $height={slice.primary?.height.text}>
      {image && <GatsbyImage image={image} alt={slice.primary?.image.alt ?? ''} objectFit="contain" />}
    </ImageWrap>
  );
};

export default ImageSlice;

interface StyleProps {
  $width?: string;
  $height?: string;
}

const ImageWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  height: auto;
  max-width: ${(props: StyleProps) => props.$width};
  max-height: ${(props: StyleProps) => props.$height};
`;
